import { Link } from 'react-router-dom';
import logoIcon from '../../Images/IconLogo/logo.png';

export const Logo = () => {
 
    return <div className="logo" ><Link to="/"><img src={logoIcon} alt="Logo ISI" width="95px" height="95px" /></Link></div>
}